import { isSolutionsPreviewPath, SOLUTIONS_PREVIEW_ENABLED } from './solutionsPreview'

/** Only these browser-tab pages may render before the SSO check finishes. */
export function canRenderPublicMarketing(pathname: string, standalone: boolean, oauthCallback: boolean) {
  return !standalone && !oauthCallback && (pathname === '/' || pathname === '/landing' ||
    isSolutionsPreviewPath(pathname) ||
    (SOLUTIONS_PREVIEW_ENABLED && (pathname === '/otslezhivanie-bez-gps' || pathname === '/for-logists')))
}

export function hasOAuthResponse(search: string, hash: string) {
  const query = new URLSearchParams(search)
  const fragment = new URLSearchParams(hash.replace(/^#/, ''))
  return ['code', 'state', 'error'].some((key) => query.has(key) || fragment.has(key))
}
